
import { Vue, Component } from 'vue-property-decorator';
import T from '../../lang';
import testimonialsConfig from '../../testimonials.config';

@Component
export default class Testimonials extends Vue {
  T = T;
  testimonials = testimonialsConfig;
}
